import AdminReviewsTable from '@website/components/admin/AdminReviews/ReviewsTable';
import AdminReviewStats from '@website/components/admin/AdminReviews/ReviewSummary';
import { useState } from 'react';
import { Nav } from 'react-bootstrap';
import AdminLayout from '../../components/layouts/adminLayout';

export default function AdminDashboardPage() {
  const [activeTab, setActiveTab] = useState<'reviews' | 'stats'>('reviews');

  return (
    <AdminLayout>
      <Nav variant="tabs" className="my-2" defaultActiveKey={'recent-bookings'}>
        <Nav.Item key="recent-bookings">
          <Nav.Link
            active={activeTab === 'reviews'}
            role="button"
            onClick={() => setActiveTab('reviews')}
          >
            Recent Reviews
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            active={activeTab === 'stats'}
            role="button"
            onClick={() => {
              setActiveTab('stats');
            }}
          >
            Review Summary
          </Nav.Link>
        </Nav.Item>
      </Nav>
      {activeTab === 'stats' ? <AdminReviewStats /> : <AdminReviewsTable />}
    </AdminLayout>
  );
}
